import { supabase } from "@/integrations/supabase/client";

interface ErrorLogData {
  errorMessage: string;
  errorStack?: string;
  componentName?: string;
  metadata?: Record<string, unknown>;
}

export async function logError(data: ErrorLogData): Promise<void> {
  try {
    const { data: userData } = await supabase.auth.getUser();
    
    // Using type assertion since error_logs table was just created
    await (supabase.from('error_logs') as any).insert({
      error_message: data.errorMessage,
      error_stack: data.errorStack,
      component_name: data.componentName,
      user_id: userData?.user?.id || null,
      user_agent: navigator.userAgent,
      url: window.location.href,
      metadata: data.metadata || {},
    });
  } catch (e) {
    // Silently fail - we don't want error logging to cause more errors
    console.error('Failed to log error:', e);
  }
}

// Global error handler
export function setupGlobalErrorHandler(): void {
  window.onerror = (message, source, lineno, colno, error) => {
    logError({
      errorMessage: String(message),
      errorStack: error?.stack,
      componentName: 'GlobalErrorHandler',
      metadata: { source, lineno, colno },
    });
    return false;
  };

  window.onunhandledrejection = (event) => {
    logError({
      errorMessage: event.reason?.message || String(event.reason),
      errorStack: event.reason?.stack,
      componentName: 'UnhandledPromiseRejection',
    });
  };
}
